var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHostingDashboardHeaderWave = function SvgHostingDashboardHeaderWave(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    preserveAspectRatio: "none",
    viewBox: "0 0 1440 55"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#251628",
    fillRule: "evenodd",
    d: "M.148 0C63.368 33.36 220.75 69.852 539.5 48.5c539.08-36.11 749.21-36.742 900.5-5.383V0z",
    clipRule: "evenodd"
  })));
};
export default SvgHostingDashboardHeaderWave;